export const languageStringsAdmin = {
  title: "Ügyfelek",
  pricingPeriod: {
    monthly: "Havi",
    yearly: "Éves",
  },
  table: {
    email: "Email",
    fullName: "Teljes név",
    accountType: "Fiók típusa",
    websites: "Weboldalak",
    campaigns: "Kampányok",
    subscription: "Előfizetés",
    takeControl: "Átvétel",
    loginButton: "Bejelentkezés",
    noSubscription: "-------",
  },
  tools: {
    button: "Admin eszközök",
    modalTitle: "Admin eszközök",
    title: "Admin eszközök",
    clearCache: "Gyorsítótár törlése",
    error: "Hiba a művelet végrehajtása során",
    clearGoogleReviewsCache: {
      title: "Google értékelések gyorsítótárának törlése",
      description:
        "Az összes webhely Google értékelési adatainak gyorsítótárának törlése. Az értékelések a következő kérésnél újra lekérésre kerülnek az egyes webhelyekhez beállított nyelven.",
      success: "A Google értékelések gyorsítótára sikeresen törölve",
    },
  },
  errorLogs: {
    button: "Hibanaplók",
    title: "Hibanaplók (frontend)",
    empty: "Nincs naplózott hiba.",
  },
};
